export class ICalculatedResultProvider {
  applyRatio = (value, ratio) => {};

  getCalculatedResult() {}
}
